<template>
  <div class="fill-height">
    <Progress
      key="default-loading"
      :show="loading"
    />
    <!-- Mostra o conteúdo quando não estiver carregando -->
    <slot v-if="!loading"></slot>
  </div>
</template>

<script>
import Progress from './Progress'
/**
 * @group Resquest Flow Control
 * Principalmente usado para controlar a visualização de um conteúdo
 * que precisa de um prévio carregamento(precisa ser requisitado). Por
 * padrão usa o componente [Progress](/components/Progress) para indicar
 * o status.
*/
export default {
  name: 'Spinner',

  components: {
    Progress
  },

  props: {
    // Status de carregamento
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
